// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l8l9","expireSoon":"styles_expireSoon__1CZPZ"};